import { Logger } from './logger';
export { LOG_LEVEL, LOG_CUSTOM_ATTRIBUTE, LOG_INFO } from './types';
export { fancyLog } from './utils';

export const logger = new Logger({
  debug: process.env.REACT_APP_ENVIRONMENT !== 'prod' || localStorage.getItem('REACT_APP_LOGGER_DEBUG') === '1',
});
